module.exports = __webpack_public_path__ + "static/media/blanket.02766c39.svg";